
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const SermonsSection = () => {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation();
  const sermons = t('sermons.items', { returnObjects: true }) as Array<{
    title: string;
    pastor: string;
    date: string;
    videoUrl: string;
    description: string;
  }>;

  const handleSermonClick = (videoUrl: string) => {
    if (videoUrl && videoUrl !== '#') {
      window.open(videoUrl, '_blank');
    }
  };

  const getSermonImage = (index: number) => {
    // Usar la imagen específica para el primer sermón
    if (index === 0) {
      return 'https://static.readdy.ai/image/c96c1e7a1b8af8480a4ca8f0b32ab500/a8ca77b122ff4285ab74226ac1eb4b24.jpeg';
    }
    // Usar la imagen específica para el segundo sermón
    if (index === 1) {
      return 'https://static.readdy.ai/image/c96c1e7a1b8af8480a4ca8f0b32ab500/6548d7a44b40fc1d4155089737c6ecf8.jpeg';
    }
    // Usar la imagen específica para el tercer sermón
    if (index === 2) {
      return 'https://static.readdy.ai/image/c96c1e7a1b8af8480a4ca8f0b32ab500/ef38ea076b26c75e9d05f34c9823ea49.jpeg';
    }
    // Para los demás sermones, usar imágenes generadas
    return `https://public.readdy.ai/ai/img_res/7f69735a92945a967a0f2b1e1f9a8e54.jpg${index + 1}&orientation=landscape`;
  };

  return (
    <section 
      id="sermons"
      ref={ref}
      className={`py-12 sm:py-16 md:py-24 bg-neutral-50 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight mb-3 sm:mb-4 sm:mb-6 px-2">
            {t('sermons.title')}
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed px-4">
            {t('sermons.subtitle')}
          </p>
        </div>

        <div className="grid gap-4 sm:gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 px-2 sm:px-0">
          {sermons.map((sermon, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl shadow-lg overflow-hidden group cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              onClick={() => handleSermonClick(sermon.videoUrl)}
            >
              <div className="relative h-40 sm:h-48 md:h-52 bg-gradient-to-br from-blue-600 to-purple-700 overflow-hidden">
                <img
                  src={getSermonImage(index)}
                  alt={sermon.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/20"></div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="bg-white/90 rounded-full p-2 sm:p-3 md:p-4 shadow-lg">
                    <i className="ri-play-fill text-lg sm:text-xl md:text-2xl text-blue-600"></i>
                  </div>
                </div>
              </div>
              
              <div className="p-3 sm:p-4 md:p-6">
                <div className="flex flex-col gap-1 sm:gap-2 mb-2 sm:mb-3">
                  <span className="text-xs sm:text-sm text-blue-600 font-medium">
                    {sermon.date}
                  </span>
                  <span className="text-xs text-neutral-500 truncate">
                    {sermon.pastor}
                  </span>
                </div>
                
                <h3 className="text-sm sm:text-lg md:text-xl font-bold text-neutral-900 mb-2 sm:mb-3 group-hover:text-blue-600 transition-colors leading-tight line-clamp-2">
                  {sermon.title}
                </h3>
                
                <p className="text-neutral-600 text-xs sm:text-sm md:text-base mb-3 sm:mb-4 line-clamp-3 leading-relaxed">
                  {sermon.description}
                </p>
                
                <button 
                  className="w-full bg-blue-600 text-white py-2 sm:py-2.5 md:py-3 px-3 sm:px-4 rounded-lg hover:bg-blue-7

 00 transition-colors duration-200 font-medium whitespace-nowrap text-xs sm:text-sm md:text-base"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSermonClick(sermon.videoUrl);
                  }}
                >
                  {t('sermons.watchSermon')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SermonsSection;
